const trailer = {

	element: document.querySelector('.c26-masthead'),
	followers: document.querySelectorAll('.c26-trailers li'),
	pointer: window.matchMedia('(hover: hover)'),
	reset: null,
	
	follow(event) {
		event = event || window.event;
		let delay = 0;
		trailer.followers.forEach(function(element) {	
			setTimeout(function() {
				element.style.left = event.clientX + 'px';
				element.style.top = (event.clientY +  window.scrollY) + 'px';
				element.style.opacity = '1';
			}, delay);
			delay = delay + 250;
		});
		clearTimeout(trailer.reset);
		trailer.reset = setTimeout(trailer.stop, 250);
	},

	stop() {
		let delay = 0;		
		trailer.followers.forEach(function(element) {
			setTimeout(function() {			
				element.style.opacity = '0';
			}, delay);
			delay = delay + 250;
		});
	},
	
	init() {
		if(trailer.pointer.matches) {
			trailer.element.addEventListener('mousemove', trailer.follow);
		}
	}

};

export { trailer };




